import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet, apiPost } from '@/shared/utils/requestBuilder';
import {
  CompleteOnboardingPayload,
  CompleteOnboardingResponse,
  CreateDepartmentPayload,
  CreateDepartmentResponse,
  InviteMemberWithSectorsPayload,
  InviteMemberWithSectorsResponse,
} from '../types';

export const onboardingService = {
  validateToken: async (token: string) => {
    const params = new URLSearchParams({
      token,
    });

    const url = `/onboarding/validate-token?${params.toString()}`;
    const response = await apiGet(url);

    if (!response.ok) {
      await throwApiError(response, 'Erro ao validar token de onboarding');
    }

    const body = await response.json();

    return body?.data ?? body;
  },

  async completeOnboarding(
    payload: CompleteOnboardingPayload,
  ): Promise<CompleteOnboardingResponse> {
    const response = await apiPost('/onboarding/complete', payload);

    if (!response.ok) {
      await throwApiError(response, 'Erro ao concluir onboarding');
    }

    const data = await response.json();

    return data.data;
  },

  async createDepartment(payload: CreateDepartmentPayload): Promise<CreateDepartmentResponse> {
    const response = await apiPost('/setores', payload);
    const data = (await response.json()) as CreateDepartmentResponse;
    return data;
  },

  async convidarMembroComSetores(
    payload: InviteMemberWithSectorsPayload,
  ): Promise<InviteMemberWithSectorsResponse> {
    const { escritorioId, ...body } = payload;

    const response = await apiPost(
      `convites-escritorio/escritorio/${escritorioId}/com-setores`,
      body,
    );
    const data = (await response.json()) as InviteMemberWithSectorsResponse;
    return data;
  },
};
